import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import SubMenu from "../../Header/Navbar/SubMenu";
import "../Navbar/Navbar.css";
import { NavLink, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Index = ({ menuData }) => {
  const location = useLocation();

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const routesWithLocalEnquiry = [
    "/",
    "/about-arsus-global",
    "/our-services",
    "/our-facility",
    "/our-clients",
    "/outsource-your-bottling",
    "/career",
    "/gallery",
    "/contact-us",
  ];

  const hasLocalEnquiry =
    routesWithLocalEnquiry.includes(location.pathname) ||
    location.pathname.startsWith("/our-services/");

  const enquiryTarget = hasLocalEnquiry ? "#BusinessEnquiry" : "/#BusinessEnquiry";

  const isActive = (href) => {
    return location.pathname === href;
  };
  const [menus, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!menus);
  };

  const handleMenuClick = () => {
    setActive(false);
  };
  return (
    <div className="navbar p-0">
      <div className="col-12 float-start menuStrip">
        <div className="menu-top-row d-none">
          <div className="header-cta-group">
            <HashLink
              to={enquiryTarget}
              className="header-cta header-cta--outline"
            >
              <span className="header-cta-label">Enquire Now</span>
            </HashLink>
            <a
              href="tel:+919134320504"
              className="header-cta header-cta--solid"
            >
              <span className="header-cta-label">Call Us</span>
              <span className="header-cta-value">+91 91343 20504</span>
            </a>
          </div>
        </div>
        <div className="menu-bottom-row">
          <ul className="d-lg-flex desktop-show">
            {menuData.map((menu, index) => (
              <li key={index} onClick={handleMenuClick}>
                {menu.link ? (
                  <NavLink
                    to={menu.link}
                    className={isActive(menu.link) ? "active" : ""}
                  >
                    {menu.name}
                  </NavLink>
                ) : (
                  menu.name
                )}
                {menu.submenus && (
                  <SubMenu
                    submenus={menu.submenus}
                    showViewAllLink={menu.showViewAllLink}
                  />
                )}
              </li>
            ))}
          </ul>
          <button
            onClick={handleToggle}
            className={menus ? "hamburger active" : "hamburger"}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      <div className={menus ? "menus active" : "menus"}>

        <div className="col-lg-11 col-12 subMenu flex-center justify-content-lg-end h-100">
          <ul className="text-white">
            {menuData.map((menu, index) => (
              <li key={index} className="mobile-show" onClick={handleMenuClick}>

                {menu.link ? (
                  <NavLink
                    to={menu.link}
                    className={isActive(menu.link) ? "active" : ""}
                  >
                    {menu.name}
                  </NavLink>
                ) : (
                  menu.name
                )}
                {menu.submenus && (
                  <SubMenu
                    submenus={menu.submenus}
                    showViewAllLink={menu.showViewAllLink}
                  />
                )}
              </li>
            ))}
            <li><NavLink to='/gallery' onClick={handleMenuClick}>Gallery</NavLink></li>
            <li><NavLink to='/career' onClick={handleMenuClick}>Career</NavLink></li>
            <li><NavLink to='/contact-us' onClick={handleMenuClick}>Contact Us</NavLink></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Index;
